import { FetchStaffAPIResponse } from 'src/services/staff'
import { BaseReducerState, Staff } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchStaffState = BaseReducerState & {
  data: Staff[]
}

export const initialState: FetchStaffState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchStaff = (
  state: FetchStaffState = initialState,
  action: { type: string; res: any }
): FetchStaffState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_STAFF}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_STAFF}_SUCCESS`: {
      const { success, data, message } = <FetchStaffAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_STAFF}_FAILURE`:
      const res = <FetchStaffAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_STAFF}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
